// Mirrors the `updateState` values produced by the user reducer
// (see `src/reducers/user.js` initialState comment).
export const UPDATE_SUCCESS = 2;

// Company-type options for the profile / host-information selectors.
// `ORGANIZATION` ("Förening") is deprecated -- no longer offered to new
// or other users since we can't verify it, but kept visible for accounts
// that already have it selected so their profile still renders and saves
// (STU-261).
export const getCompanyTypeOptions = (intl, currentValue) => {
  const options = [
    {
      value: 'BUSINESS',
      label: intl.formatMessage({ id: 'Business', defaultMessage: 'Business' }),
    },
    {
      value: 'SOLETRADER',
      label: intl.formatMessage({ id: 'Sole Trader', defaultMessage: 'Sole Trader' }),
    },
  ];

  if (currentValue === 'ORGANIZATION') {
    // Preserve original order (Business, Organization, Sole Trader).
    options.splice(1, 0, {
      value: 'ORGANIZATION',
      label: intl.formatMessage({ id: 'Organization', defaultMessage: 'Organization' }),
    });
  }

  return options;
};
